import {WorkdayStatus} from '@lib/store/src/data/timeslots/apiTypes';
import {IconNames} from 'mapiq-atoms';

export const IconStatusMapping: Record<WorkdayStatus, IconNames> = {
  NotWorking: 'calendarX',
  OfficeDay: 'office',
  WorkingRemotely: 'remote',
};
